import { SONAR_DATA_KEYS } from './chart';
import round from './round';

export const createGroupsData = (domainEntries) => {
  const keys = Object.values(SONAR_DATA_KEYS);

  const map = domainEntries.reduce((acc, entry) => {
    (entry.groups || []).forEach((group) => {
      acc[group] = acc[group] || { domain: group, ...createEmptyStats(keys) };

      keys.forEach((key) => {
        if (entry[key]) {
          const { score, prevScore, trend } = entry[key];
          const groupStat = acc[group][key];
          groupStat.score = (groupStat.score || 0) + (score || 0);
          groupStat.prevScore = (groupStat.prevScore || 0) + (prevScore || 0);
          groupStat.trend = (groupStat.trend || 0) + (trend || 0);
        }
      });
    });

    return acc;
  }, {});

  const groupEntries = Object.values(map).map((group) => ({
    ...group,
    ...roundStats(group, keys),
  }));

  return groupEntries;
};

function createEmptyStats(keys) {
  return keys.reduce((acc, key) => {
    acc[key] = {};
    return acc;
  }, {});
}

function roundStats(entry, keys) {
  keys.forEach((key) => {
    const stat = entry[key];
    stat.score !== undefined && (stat.score = round(stat.score));
    stat.prevScore !== undefined && (stat.prevScore = round(stat.prevScore));
    stat.trend !== undefined && (stat.trend = round(stat.trend));
  });

  return entry;
}
